import { SvgIndexable } from "./Icon.props";
import { ReactComponent as ArrowBottomLeft } from "./svg/arrow-bottom-left.svg";
import { ReactComponent as ArrowBottomRight } from "./svg/arrow-bottom-right.svg";
import { ReactComponent as ArrowCircledBottomLeft } from "./svg/arrow-circled-bottom-left.svg";
import { ReactComponent as ArrowCircledBottomRight } from "./svg/arrow-circled-bottom-right.svg";
import { ReactComponent as ArrowCircledDown } from "./svg/arrow-circled-down.svg";
import { ReactComponent as ArrowCircledLeft } from "./svg/arrow-circled-left.svg";
import { ReactComponent as ArrowCircledRight } from "./svg/arrow-circled-right.svg";
import { ReactComponent as ArrowCircledTopLeft } from "./svg/arrow-circled-top-left.svg";
import { ReactComponent as ArrowCircledTopRight } from "./svg/arrow-circled-top-right.svg";
import { ReactComponent as ArrowCircledUp } from "./svg/arrow-circled-up.svg";
import { ReactComponent as ArrowDownLeft } from "./svg/arrow-down-left.svg";
import { ReactComponent as ArrowDownRight } from "./svg/arrow-down-right.svg";
import { ReactComponent as ArrowDown } from "./svg/arrow-down.svg";
import { ReactComponent as ArrowLeft } from "./svg/arrow-left.svg";
import { ReactComponent as ArrowRight } from "./svg/arrow-right.svg";
import { ReactComponent as ArrowUpLeft } from "./svg/arrow-up-left.svg";
import { ReactComponent as ArrowUpRight } from "./svg/arrow-up-right.svg";
import { ReactComponent as ArrowUp } from "./svg/arrow-up.svg";
import { ReactComponent as Avatar2People } from "./svg/avatar-2-people.svg";
import { ReactComponent as Avatar3People } from "./svg/avatar-3-people.svg";
import { ReactComponent as AvatarAdd } from "./svg/avatar-add.svg";
import { ReactComponent as AvatarPatient } from "./svg/avatar-patient.svg";
import { ReactComponent as AvatarSquare } from "./svg/avatar-square.svg";
import { ReactComponent as Avatar } from "./svg/avatar.svg";
import { ReactComponent as Box } from "./svg/box.svg";
import { ReactComponent as Buildings1 } from "./svg/buildings-1.svg";
import { ReactComponent as Buildings2 } from "./svg/buildings-2.svg";
import { ReactComponent as Calendar } from "./svg/calendar.svg";
import { ReactComponent as CaratDownCircle } from "./svg/carat-down-circle.svg";
import { ReactComponent as CaratDown } from "./svg/carat-down.svg";
import { ReactComponent as CaratLeftCircle } from "./svg/carat-left-circle.svg";
import { ReactComponent as CaratLeftEnd } from "./svg/carat-left-end.svg";
import { ReactComponent as CaratLeft } from "./svg/carat-left.svg";
import { ReactComponent as CaratRightCircle } from "./svg/carat-right-circle.svg";
import { ReactComponent as CaratRightEnd } from "./svg/carat-right-end.svg";
import { ReactComponent as CaratRight } from "./svg/carat-right.svg";
import { ReactComponent as CaratUpCircle } from "./svg/carat-up-circle.svg";
import { ReactComponent as CaratUp } from "./svg/carat-up.svg";
import { ReactComponent as Cards } from "./svg/cards.svg";
import { ReactComponent as CheckMarkCircle } from "./svg/check-mark-circle.svg";
import { ReactComponent as CheckMark } from "./svg/check-mark.svg";
import { ReactComponent as ChildArrow } from "./svg/child-arrow.svg";
import { ReactComponent as CirclesStack } from "./svg/circles-stack.svg";
import { ReactComponent as Clock } from "./svg/clock.svg";
import { ReactComponent as CloudCheck } from "./svg/cloud-check.svg";
import { ReactComponent as CloudLock } from "./svg/cloud-lock.svg";
import { ReactComponent as CloudPerson } from "./svg/cloud-person.svg";
import { ReactComponent as CloudX } from "./svg/cloud-x.svg";
import { ReactComponent as Cloud } from "./svg/cloud.svg";
import { ReactComponent as ComputerDesktop } from "./svg/computer-desktop.svg";
import { ReactComponent as Copy } from "./svg/copy.svg";
import { ReactComponent as Create } from "./svg/create.svg";
import { ReactComponent as CustomerService } from "./svg/customer-service.svg";
import { ReactComponent as DataMolecule } from "./svg/data-molecule.svg";
import { ReactComponent as Division } from "./svg/division.svg";
import { ReactComponent as DocumentPageFold } from "./svg/document-page-fold.svg";
import { ReactComponent as Document } from "./svg/document.svg";
import { ReactComponent as Download } from "./svg/download.svg";
import { ReactComponent as EnvelopeClosed } from "./svg/envelope-closed.svg";
import { ReactComponent as EnvelopeOpen } from "./svg/envelope-open.svg";
import { ReactComponent as Eye } from "./svg/eye.svg";
import { ReactComponent as FaceId } from "./svg/face-id.svg";
import { ReactComponent as Facebook } from "./svg/facebook.svg";
import { ReactComponent as FilterChannels } from "./svg/filter-channels.svg";
import { ReactComponent as FilterFunnel } from "./svg/filter-funnel.svg";
import { ReactComponent as FingerprintTouchId } from "./svg/fingerprint-touch-id.svg";
import { ReactComponent as Flowchart1 } from "./svg/flowchart-1.svg";
import { ReactComponent as Flowchart2 } from "./svg/flowchart-2.svg";
import { ReactComponent as Gear } from "./svg/gear.svg";
import { ReactComponent as GraphBar } from "./svg/graph-bar.svg";
import { ReactComponent as GraphLine } from "./svg/graph-line.svg";
import { ReactComponent as GraphReporting } from "./svg/graph-reporting.svg";
import { ReactComponent as Grid4 } from "./svg/grid-4.svg";
import { ReactComponent as HandMoney } from "./svg/hand-money.svg";
import { ReactComponent as Heart } from "./svg/heart.svg";
import { ReactComponent as Home } from "./svg/home.svg";
import { ReactComponent as Hourglass } from "./svg/hourglass.svg";
import { ReactComponent as Info } from "./svg/info.svg";
import { ReactComponent as Instagram } from "./svg/instagram.svg";
import { ReactComponent as Invoice } from "./svg/invoice.svg";
import { ReactComponent as LighteningBolt } from "./svg/lightening-bolt.svg";
import { ReactComponent as LinkOut } from "./svg/link-out.svg";
import { ReactComponent as LinkedIn } from "./svg/linkedin-logo.svg";
import { ReactComponent as ListBullet2 } from "./svg/list-bullet-2.svg";
import { ReactComponent as List } from "./svg/list.svg";
import { ReactComponent as LocationArrow } from "./svg/location-arrow.svg";
import { ReactComponent as LocationPlus } from "./svg/location-plus.svg";
import { ReactComponent as LocationStandard } from "./svg/location-standard.svg";
import { ReactComponent as LockCloud } from "./svg/lock-cloud.svg";
import { ReactComponent as Lock } from "./svg/lock.svg";
import { ReactComponent as LogOut } from "./svg/log-out.svg";
import { ReactComponent as MagnifyingGlassGraph } from "./svg/magnifying-glass-graph.svg";
import { ReactComponent as MagnifyingGlass } from "./svg/magnifying-glass.svg";
import { ReactComponent as Mailbox } from "./svg/mailbox.svg";
import { ReactComponent as Manufacturer } from "./svg/manufacturer.svg";
import { ReactComponent as Map } from "./svg/map.svg";
import { ReactComponent as Medical } from "./svg/medical.svg";
import { ReactComponent as MenuCollapse } from "./svg/menu-collapse.svg";
import { ReactComponent as MenuDotsHorizontalCircle } from "./svg/menu-dots-horizontal-circle.svg";
import { ReactComponent as MenuDotsHorizontal } from "./svg/menu-dots-horizontal.svg";
import { ReactComponent as MenuDotsVerticalCircle } from "./svg/menu-dots-vertical-circle.svg";
import { ReactComponent as MenuDotsVertical } from "./svg/menu-dots-vertical.svg";
import { ReactComponent as MenuExpand } from "./svg/menu-expand.svg";
import { ReactComponent as MenuHamburger } from "./svg/menu-hamburger.svg";
import { ReactComponent as MessageDots } from "./svg/message-dots.svg";
import { ReactComponent as MinorityOwned } from "./svg/minority-owned.svg";
import { ReactComponent as MinusSignCircle } from "./svg/minus-sign-circle.svg";
import { ReactComponent as MinusSign } from "./svg/minus-sign.svg";
import { ReactComponent as MoneyArrow } from "./svg/money-arrow.svg";
import { ReactComponent as MoneyCoin } from "./svg/money-coin.svg";
import { ReactComponent as Move } from "./svg/move.svg";
import { ReactComponent as NetworkGlobe } from "./svg/network-globe.svg";
import { ReactComponent as Notifications } from "./svg/notifications.svg";
import { ReactComponent as PaperclipAttachment } from "./svg/paperclip-attachment.svg";
import { ReactComponent as Percent } from "./svg/percent.svg";
import { ReactComponent as PersonOutreach } from "./svg/person-outreach.svg";
import { ReactComponent as Pharmacy } from "./svg/pharmacy.svg";
import { ReactComponent as PhoneLandline } from "./svg/phone-landline.svg";
import { ReactComponent as PhoneMobile } from "./svg/phone-mobile.svg";
import { ReactComponent as PillBottleMoney } from "./svg/pill-bottle-money.svg";
import { ReactComponent as PillBottlePill } from "./svg/pill-bottle-pill.svg";
import { ReactComponent as PillBottle } from "./svg/pill-bottle.svg";
import { ReactComponent as PlusSignCircle } from "./svg/plus-sign-circle.svg";
import { ReactComponent as PlusSign } from "./svg/plus-sign.svg";
import { ReactComponent as PrescriptionBackground } from "./svg/prescription-background.svg";
import { ReactComponent as Prescription } from "./svg/prescription.svg";
import { ReactComponent as Printer } from "./svg/printer.svg";
import { ReactComponent as QuestionMarkCircle } from "./svg/question-mark-circle.svg";
import { ReactComponent as Redo } from "./svg/redo.svg";
import { ReactComponent as RefreshCloud } from "./svg/refresh-cloud.svg";
import { ReactComponent as RefreshLocation } from "./svg/refresh-location.svg";
import { ReactComponent as RefreshStar } from "./svg/refresh-star.svg";
import { ReactComponent as Refresh } from "./svg/refresh.svg";
import { ReactComponent as RibbonStar } from "./svg/ribbon-star.svg";
import { ReactComponent as Ribbon } from "./svg/ribbon.svg";
import { ReactComponent as ScaleWeight } from "./svg/scale-weight.svg";
import { ReactComponent as Science1 } from "./svg/science-1.svg";
import { ReactComponent as Science2 } from "./svg/science-2.svg";
import { ReactComponent as SelectPointer } from "./svg/select-pointer.svg";
import { ReactComponent as Share } from "./svg/share.svg";
import { ReactComponent as StarEmpty } from "./svg/star-empty.svg";
import { ReactComponent as StarFilled } from "./svg/star-filled.svg";
import { ReactComponent as StopPill } from "./svg/stop-pill.svg";
import { ReactComponent as Strategy } from "./svg/strategy.svg";
import { ReactComponent as ThumbsDown } from "./svg/thumbs-down.svg";
import { ReactComponent as ThumbsUp } from "./svg/thumbs-up.svg";
import { ReactComponent as Trash } from "./svg/trash.svg";
import { ReactComponent as Twitter } from "./svg/twitter-logo.svg";
import { ReactComponent as Undo } from "./svg/undo.svg";
import { ReactComponent as UserPermissions } from "./svg/user-permissions.svg";
import { ReactComponent as Versions } from "./svg/versions.svg";
import { ReactComponent as Warning } from "./svg/warning.svg";
import { ReactComponent as Wrench } from "./svg/wrench.svg";
import { ReactComponent as XCircle } from "./svg/x-circle.svg";
import { ReactComponent as X } from "./svg/x.svg";
import { ReactComponent as YouTube } from "./svg/youtube-logo.svg";

const IconNames: SvgIndexable = {
  "arrow-bottom-right": ArrowBottomRight,
  "arrow-bottom-left": ArrowBottomLeft,
  "arrow-circled-bottom-left": ArrowCircledBottomLeft,
  "arrow-circled-bottom-right": ArrowCircledBottomRight,
  "arrow-circled-down": ArrowCircledDown,
  "arrow-circled-left": ArrowCircledLeft,
  "arrow-circled-right": ArrowCircledRight,
  "arrow-circled-top-left": ArrowCircledTopLeft,
  "arrow-circled-top-right": ArrowCircledTopRight,
  "arrow-circled-up": ArrowCircledUp,
  "arrow-down-left": ArrowDownLeft,
  "arrow-down-right": ArrowDownRight,
  "arrow-down": ArrowDown,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up-left": ArrowUpLeft,
  "arrow-up-right": ArrowUpRight,
  "arrow-up": ArrowUp,
  "avatar-2-people": Avatar2People,
  "avatar-3-people": Avatar3People,
  "avatar-add": AvatarAdd,
  "avatar-patient": AvatarPatient,
  "avatar-square": AvatarSquare,
  avatar: Avatar,
  box: Box,
  "buildings-1": Buildings1,
  "buildings-2": Buildings2,
  calendar: Calendar,
  "carat-down-circle": CaratDownCircle,
  "carat-down": CaratDown,
  "carat-left-circle": CaratLeftCircle,
  "carat-left": CaratLeft,
  "carat-left-end": CaratLeftEnd,
  "carat-right-circle": CaratRightCircle,
  "carat-right": CaratRight,
  "carat-right-end": CaratRightEnd,
  "carat-up-circle": CaratUpCircle,
  "carat-up": CaratUp,
  cards: Cards,
  "check-mark": CheckMark,
  "check-mark-circle": CheckMarkCircle,
  "child-arrow": ChildArrow,
  "circles-stack": CirclesStack,
  clock: Clock,
  "cloud-check": CloudCheck,
  "cloud-lock": CloudLock,
  "cloud-person": CloudPerson,
  "cloud-x": CloudX,
  cloud: Cloud,
  "computer-desktop": ComputerDesktop,
  copy: Copy,
  create: Create,
  "customer-service": CustomerService,
  "data-molecule": DataMolecule,
  division: Division,
  "document-page-fold": DocumentPageFold,
  document: Document,
  download: Download,
  "envelope-closed": EnvelopeClosed,
  "envelope-open": EnvelopeOpen,
  eye: Eye,
  facebook: Facebook,
  "face-id": FaceId,
  "filter-channels": FilterChannels,
  "filter-funnel": FilterFunnel,
  "fingerprint-touch-id": FingerprintTouchId,
  "flowchart-1": Flowchart1,
  "flowchart-2": Flowchart2,
  gear: Gear,
  "graph-bar": GraphBar,
  "graph-line": GraphLine,
  "graph-reporting": GraphReporting,
  "grid-4": Grid4,
  "hand-money": HandMoney,
  heart: Heart,
  home: Home,
  hourglass: Hourglass,
  info: Info,
  instagram: Instagram,
  invoice: Invoice,
  "lightening-bolt": LighteningBolt,
  "link-out": LinkOut,
  "linked-in": LinkedIn,
  "list-bullet-2": ListBullet2,
  list: List,
  "location-arrow": LocationArrow,
  "location-plus": LocationPlus,
  "location-standard": LocationStandard,
  "lock-cloud": LockCloud,
  lock: Lock,
  "log-out": LogOut,
  "magnifying-glass-graph": MagnifyingGlassGraph,
  "magnifying-glass": MagnifyingGlass,
  mailbox: Mailbox,
  manufacturer: Manufacturer,
  map: Map,
  medical: Medical,
  "menu-collapse": MenuCollapse,
  "menu-dots-horizontal-circle": MenuDotsHorizontalCircle,
  "menu-dots-horizontal": MenuDotsHorizontal,
  "menu-dots-vertical-circle": MenuDotsVerticalCircle,
  "menu-dots-vertical": MenuDotsVertical,
  "menu-expand": MenuExpand,
  "menu-hamburger": MenuHamburger,
  "message-dots": MessageDots,
  "minority-owned": MinorityOwned,
  "minus-sign-circle": MinusSignCircle,
  "minus-sign": MinusSign,
  "money-arrow": MoneyArrow,
  "money-coin": MoneyCoin,
  move: Move,
  "network-globe": NetworkGlobe,
  notifications: Notifications,
  "paperclip-attachment": PaperclipAttachment,
  percent: Percent,
  "person-outreach": PersonOutreach,
  pharmacy: Pharmacy,
  "phone-landline": PhoneLandline,
  "phone-mobile": PhoneMobile,
  "pill-bottle-money": PillBottleMoney,
  "pill-bottle-pill": PillBottlePill,
  "pill-bottle": PillBottle,
  "plus-sign-circle": PlusSignCircle,
  "plus-sign": PlusSign,
  prescription: Prescription,
  "prescription-background": PrescriptionBackground,
  printer: Printer,
  "question-mark-circle": QuestionMarkCircle,
  redo: Redo,
  refresh: Refresh,
  "refresh-cloud": RefreshCloud,
  "refresh-location": RefreshLocation,
  "refresh-star": RefreshStar,
  "ribbon-star": RibbonStar,
  ribbon: Ribbon,
  "scale-weight": ScaleWeight,
  "science-1": Science1,
  "science-2": Science2,
  "select-pointer": SelectPointer,
  share: Share,
  "star-empty": StarEmpty,
  "star-filled": StarFilled,
  "stop-pill": StopPill,
  strategy: Strategy,
  "thumbs-down": ThumbsDown,
  "thumbs-up": ThumbsUp,
  trash: Trash,
  twitter: Twitter,
  undo: Undo,
  "user-permission": UserPermissions,
  "user-permissions": UserPermissions,
  versions: Versions,
  warning: Warning,
  wrench: Wrench,
  "x-circle": XCircle,
  x: X,
  youtube: YouTube,
};

/**
 * @deprecated
 */
export default IconNames;
